// src/components/MyteGroupWebsite/Header.js

"use client"

import { useState, useEffect } from "react"
import {
  Menu,
  X,
} from "lucide-react"

// Header Component
export default function Header({ isMenuOpen, setIsMenuOpen, activeSection }) {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10)
    }

    window.addEventListener("scroll", handleScroll, { passive: true })
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  // The same navLinks from HomePage.js
  const navLinks = [
    { name: "About", href: "/about" },
    { name: "Solutions", href: "#solutions" },
    { name: "Training", href: "#training" },
    { name: "Success Stories", href: "#success-stories" },
    { name: "Pricing", href: "#pricing" },
    { name: "Testimonials", href: "#testimonials" },
    // ADDED VIDEO DEMOS LINK: external path to MyteConstruction's VideoDemosPage
    { name: "Video Demos", href: "/videos" },
    { name: "Contact", href: "#contact" },
  ]

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-[#0e1d34]/90 backdrop-blur-md shadow-lg" : "bg-[#0e1d34]"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
        {/* Logo */}
        <div className="flex justify-center">
          <a href="/" className="flex items-center">
            <img src="/LogoFile.png" alt="Myte Group Logo" className="w-28 sm:w-36 h-auto max-w-full object-contain" />
          </a>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-4 lg:space-x-6">
          {navLinks.map((link) => {
            const isAnchorLink = link.href.startsWith("#")
            return (
              <a
                key={link.name}
                href={link.href}
                className={`text-sm font-medium transition-colors duration-300 ${
                  // highlight the anchor link if activeSection matches
                  isAnchorLink && activeSection === link.href.substring(1) ? "text-white" : "text-blue-200"
                } hover:text-white`}
              >
                {link.name}
              </a>
            )
          })}
          <a
            href="https://calendly.com/ahmed-mekallach/generative_ai_discovery_call"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#3080c1] hover:bg-[#246399] text-white px-4 py-2 rounded-md transition-all duration-300"
          >
            Schedule a Call
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="md:hidden text-white bg-transparent border-none p-1"
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-[#0e1d34]/95 backdrop-blur-md p-4 animate-fadeIn">
          <nav className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-lg text-blue-200 hover:text-white transition-colors duration-300"
                onClick={() => setIsMenuOpen(false)}
              >
                {link.name}
              </a>
            ))}
            <a
              href="https://calendly.com/ahmed-mekallach/generative_ai_discovery_call"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsMenuOpen(false)}
              className="bg-[#3080c1] hover:bg-[#246399] text-white w-full mt-2 px-4 py-2 rounded-md text-center transition-all duration-300"
            >
              Schedule a Call
            </a>
          </nav>
        </div>
      )}
    </header>
  )
}
